import { Factory } from 'miragejs';

const CHANNELS = ['atm', 'pos', 'ecommerce'];

export default Factory.extend({
  merchantName: 'sncf',
  channelType: i => CHANNELS[i % CHANNELS.length],
});
